"use strict";

require("./jsonrpc");